export { WatchmanIntentionsScreen as default } from '@/src/features/watchman/ui/screens/WatchmanIntentionsScreen'
